<template>
    <v-app>
        <div>
            <MainNavigation />
            <v-main>
                <v-container>
                    <router-view></router-view>
                </v-container>
            </v-main>

        </div>
    </v-app>
</template>

<script setup lang="ts">
    import { onMounted } from 'vue';
    import MainNavigation from '@/ComponentsChild/MainNavigation.vue';
    // eslint-disable-next-line
    import { useAuth0, Auth0Symbol } from '@/Services/Auth0/auth0-plugin';

    const auth0 = useAuth0()

    onMounted(async() => {
        if (!auth0) {
            console.log('auth0 on app.vue has no value')
            return;
        }
        console.log('app.vue createClient')
        await auth0.createClient();
        await auth0.handleCallback();
        
    })       

//export default defineComponent({
//  name: 'App',
//  components: {
//    MainNavigation
//  }
//});
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
